import Axios from "axios";
import {
  GET_USERS,
  POST_USER,
  DELETE_USER,
  UPDATE_USER,
  LOADING_USER,
  CLEAR_ERRORS,
  GET_ERRORS,
  SET_CURRENT_USER,
} from "./types";
const token = document.querySelector('meta[name="csrf-token"]').content;
Axios.defaults.headers.common["X-CSRF-Token"] = token;

const success = () => {
  if (!document.getElementById("userAlert-s")) return;
  document.getElementById("userAlert-s").style.display = "block";
  setTimeout(
    () => (document.getElementById("userAlert-s").style.display = "none"),
    5000
  );
};
const error = () => {
  if (!document.getElementById("userAlert-e")) return;
  document.getElementById("userAlert-e").style.display = "block";
  setTimeout(
    () => (document.getElementById("userAlert-e").style.display = "none"),
    5000
  );
};

export const postUser = (dataBody) => (dispatch) => {
  return Axios.post("/api/v1/users", dataBody)
    .then((res) => {
      dispatch({
        type: POST_USER,
        payload: res.data,
      });
      success("post");
      return { success: true };
    })
    .catch((err) => {
      error();
      return { success: false, errors: err.response.data };
    });
};

export const getUsers = (page, pageCount, filter) => (dispatch) => {
  dispatch(setUserLoading());
  Axios.get(`/api/v1/users?page=${page}&per_page=${pageCount}${filter}`)
    .then((res) => {
      dispatch({
        type: GET_USERS,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const updateUser = (_id, body) => (dispatch, getState) => {
  return Axios.put(`/api/v1/users/${_id}`, body)
    .then((res) => {
      dispatch({
        type: UPDATE_USER,
        payload: res.data,
      });
      const user = getState().auth.user;
      if (_id == user.id) {
        dispatch({
          type: SET_CURRENT_USER,
          payload: { ...user, ...res.data },
        });
      }
      success("update");
      return { success: true, data: res.data };
    })
    .catch((err) => {
      console.log(err);
      error();
      return { success: false, errors: err.response.data };
    });
};
export const updateUserCurrent = (_id, body) => (dispatch) => {
  Axios.put(`/api/v1/users/${_id}`, body)
    .then((res) => {
      dispatch(clearErrors());
      dispatch({
        type: UPDATE_USER,
        payload: res.data,
        payload_id: _id,
      });
      dispatch({
        type: SET_CURRENT_USER,
        payload: res.data,
      });
      success("update");
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
      error();
    });
};

export const deleteUer = (_id) => (dispatch) => {
  if (confirm("Are you sure want to delete? ")) {
    Axios.delete(`/api/v1/users/${_id}`)
      .then((res) => {
        dispatch({
          type: UPDATE_USER,
          payload: res.data,
        });
        success();
      })
      .catch((err) => {
        dispatch({
          type: GET_ERRORS,
          payload: err.response.data,
        });
        error();
      });
  }
};

export const setUserLoading = () => {
  return {
    type: LOADING_USER,
  };
};

export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS,
  };
};
